import useItemContext from '@/hooks/useItemContext';
import React from 'react';

const ProductImageStrip = () => {
    const { item } = useItemContext();

    if (!item?.banner_url) {
        return null;
    }

    return (
        <img src={item?.banner_url} className="hidden md:block w-full h-auto object-cover" alt="banner" />
    );
};

export default ProductImageStrip;
